module.exports = __webpack_public_path__ + "img/1970East-062_WEB-min.793a422d.jpg";